// extracted by mini-css-extract-plugin
export var divider = "_k2-7";
export var itemsToggle = "_k2-8";
export var mergeModal = "_k2-1";
export var optionCard = "_k2-4";
export var radioGroup = "_k2-6";
export var radioOption = "_k2-0";
export var selected = "_k2-5";
export var shipmentOptions = "_k2-2";
export var tableOptions = "_k2-3";